<template>
  <div class="d-flex flex-column flex-grow-1">
    <BaseTopLine></BaseTopLine>
    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
    >
      <div
        class="tw-flex tw-items-end tw-gap-[20px] tw-text-white tw-max-w-[1200px]"
      >
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["registry_logs_sms_text_1"] }}
          </label>
          <div class="tw-flex tw-gap-[10px] tw-items-center">
            <BaseDatePicker
              class="tw-bg-white !tw-text-white tw-bg-opacity-[15%] tw-rounded-[3px] [&_i]:!tw-text-white tw-w-full"
              input-class="tw-app-input-dark !tw-bg-transparent"
              @change="filters.sms_logs__from.value = $event"
              :show-hour="true"
              :show-time-header="true"
              :value="filters.sms_logs__from.value"
              type="date"
              :format="`DD.MM.YYYY`"
              lang="ru"
              value-type="YYYY-MM-DD"
              :disabled-date="disabledFutureDates"
            >
            </BaseDatePicker>
            -
            <BaseDatePicker
              class="tw-bg-white !tw-text-white tw-bg-opacity-[15%] tw-rounded-[3px] [&_i]:!tw-text-white tw-w-full"
              input-class="tw-app-input-dark !tw-bg-transparent"
              @change="filters.sms_logs__to.value = $event"
              :show-hour="true"
              :show-time-header="true"
              :value="filters.sms_logs__to.value"
              type="date"
              :format="`DD.MM.YYYY`"
              lang="ru"
              value-type="YYYY-MM-DD"
              :disabled-date="disabledPastDates"
            >
            </BaseDatePicker>
          </div>
        </div>
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["registry_logs_sms_text_4"] }}
          </label>
          <BaseInputNew
            @keyupEnter="getWithFilter()"
            inputClass="tw-app-input-dark"
            placeholder=""
            :inputStyle="{ width: '100%' }"
            :disabled="false"
            @input="filters.sms_logs__phone.value = $event.value"
            :additionalParams="{ type: 'input' }"
            inputName="vehicles__id"
            :value="filters.sms_logs__phone.value"
            nameSign=""
          />
        </div>
        <div class="tw-flex tw-flex-row">
          <button
            type="button"
            class="tw-app-btn-primary"
            @click="getWithFilter()"
          >
            {{ dataLang["registry_logs_sms_text_5"] }}
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetFilter()">
            {{ dataLang["registry_logs_sms_text_6"] }}
          </button>
        </div>
      </div>
    </div>

    <div class="tw-px-[26px] tw-py-[15px]">
      <div class="tw-flex tw-justify-end tw-pb-[15px]">
        <TwBasePagination
          :page-count="adminSmsData.total / adminSmsData.limit"
          :pagination-params="adminSmsData"
          :page-range="10"
          :showLimitInput="false"
          :margin-pages="0"
          :click-handler="getWithFilter"
        >
        </TwBasePagination>
      </div>
      <ve-table
        class="fixed-header rest-style-table"
        style="width: 100%"
        :columns="columns"
        :table-data="adminSmsData.rows"
        :border-x="true"
        :border-y="true"
        row-key-field-name="sms_logs__id"
        :clickHighlight="false"
        :rowStyleOption="{
          hoverHighlight: true,
        }"
        :cellSelectionOption="{ enable: false }"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { VeTable } from "vue-easytable";
import dayjs from "dayjs";

export default {
  components: {
    VeTable,
  },
  data() {
    return {
      filters: {
        sms_logs__from: {
          value: null,
        },
        sms_logs__to: {
          value: null,
        },
        sms_logs__phone: {
          value: null,
          operator: "like",
        },
      },
    };
  },
  methods: {
    hideCode(row) {
      const result = row.sms_logs__text.replace(
        /( Код:\s*)(\d+)/,
        (match, p1, p2) => p1 + "*".repeat(p2.length)
      );
      return result;
    },
    disabledFutureDates(date) {
      return date > new Date();
    },
    disabledPastDates(date) {
      return (
        date <
          new Date(this.filters.sms_logs__from.value) - 24 * 60 * 60 * 1000 ||
        date > new Date()
      );
    },
    getWithFilter(page = 1) {
      const where = Object.entries(this.filters)
        .filter(([, config]) => config.value)
        .map(([field, config]) => ({
          field,
          value:
            config.operator === "like"
              ? `;percent;${config.value};percent;`
              : config.value,
          ...(config.operator && { operator: config.operator }),
        }));
      this.getAdminSmsAll({
        params: {
          where: JSON.stringify(where),
          page: page,
          limit: 50,
        },
      });
    },
    resetFilter() {
      for (let key in this.filters) {
        if (this.filters.hasOwnProperty(key)) {
          this.filters[key].value = null;
        }
      }
      this.getWithFilter();
    },
    ...mapActions("adminSmsModule", ["getAdminSmsAll"]),
  },

  created() {
    this.getWithFilter();
  },

  computed: {
    ...mapState("adminSmsModule", ["adminSmsData"]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    columns() {
      return [
        {
          field: "sms_logs__created_at",
          key: "sms_logs__created_at",
          title: this.dataLang["registry_logs_sms_text_7"],
          align: "center",
          width: "10%",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.sms_logs__created_at
                  ? dayjs(row.sms_logs__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "sms_logs__phone",
          key: "sms_logs__phone",
          title: this.dataLang["registry_logs_sms_text_8"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "sms_logs__cost",
          key: "sms_logs__cost",
          title: this.dataLang["registry_logs_sms_text_9"],
          align: "center",
          width: "10%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "sms_logs__text",
          key: "sms_logs__text",
          title: this.dataLang["registry_logs_sms_text_10"],
          align: "center",
          width: "60%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{this.hideCode(row)}</span>;
          },
        },
      ];
    },
  },
};
</script>
